import React from "react";
import {
  Box,
  Container,
  Grid,
  Button,
  Divider,
  Typography
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { red, orange } from "@mui/material/colors";
import PictureAsPdfRoundedIcon from "@mui/icons-material/PictureAsPdfRounded";
import OpenInNewRoundedIcon from "@mui/icons-material/OpenInNewRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { Link } from "react-router-dom";
// If you already have SectionHeader in your project, keep using it.
// Otherwise replace the <SectionHeader /> with your own headings.
export default function SyllabusSection() {
  const ORANGE_ACCENT = orange?.A400 || orange[600] || "#ff9100";

  const subjects = [
    { class: "11", name: "Physics 11th", href: "assets/syllabus/JAC_11th_Physics_Syllabus.pdf" },
    { class: "11", name: "Chemistry 11th", href: "assets/syllabus/JAC_11th_Chemistry_Syllabus.pdf" },
    { class: "11", name: "Mathematics 11th", href: "assets/syllabus/JAC_11th_Maths_Syllabus.pdf" },
    { class: "11", name: "Biology 11th", href: "assets/syllabus/JAC_11th_Biology_Syllabus.pdf" },
    { class: "11", name: "Commerce 11th", href: "assets/syllabus/Class_11_Commerce.pdf" },
    { class: "11", name: "Economics 11th", href: "assets/syllabus/JAC_11th_Economics_Syllabus.pdf" },
    { class: "11", name: "English 11th", href: "assets/syllabus/JAC_11th_English_Syllabus.pdf" },
    { class: "11", name: "Hindi 11th", href: "assets/syllabus/JAC_11th_Hindi_Elective_Syllabus.pdf" },
    { class: "11", name: "History 11th", href: "assets/syllabus/JAC_11th_History_Syllabus.pdf" },
    { class: "11", name: "Pol. Science 11th", href: "assets/syllabus/JAC_12th_POLTICAL_SCIENCE_Syllabus.pdf" },
      /**
   * assets/Class_11_Commerce.pdf
assets/Class_12_Commerce.pdf
assets/Economics_JCERT_SYLLABUS_CLASS_12.pdf
assets/JAC_11th_Biology_Syllabus.pdf
assets/JAC_11th_Chemistry_Syllabus.pdf
assets/JAC_11th_Economics_Syllabus.pdf
assets/JAC_11th_GEOGRAPHY_Syllabus.pdf
assets/JAC_11th_Hindi-Elective_Syllabus.pdf
assets/JAC_11th_History_Syllabus.pdf
assets/JAC_11th_Maths_Syllabus.pdf
assets/JAC_11th_Physics_Syllabus.pdf
assets/JAC_11th_POLTICAL-SCIENCE_Syllabus.pdf
assets/JAC_12th_Biology_Syllabus.pdf
assets/JAC_12th_Chemistry_Syllabus.pdf
assets/JAC_12th_GEOGRAPHY_Syllabus.pdf
assets/JAC_12th_Hindi-Elective_Syllabus.pdf
assets/JAC_12th_HISTORY_Syllabus.pdf
assets/JAC_12th_Maths_Syllabus.pdf
assets/JAC_12th_Physics_Syllabus.pdf
assets/JAC_12th_POLTICAL_SCIENCE_Syllabus.pdf
   */
    // { class: "11", name: "Computer Science", href: "assets/dummy.pdf" },
     { class: "12", name: "Physics 12th", href: "assets/syllabus/JAC_12th_Physics_Syllabus.pdf" },
    { class: "12", name: "Chemistry 12th", href: "assets/syllabus/JAC_12th_Chemistry_Syllabus.pdf" },
    { class: "12", name: "Mathematics 12th", href: "assets/syllabus/JAC_12th_Maths_Syllabus.pdf" },
    { class: "12", name: "Biology 12th", href: "assets/syllabus/JAC_12th_Biology_Syllabus.pdf" },
    { class: "12", name: "Commerce 12th", href: "assets/syllabus/Class_12_Commerce.pdf" },
    { class: "12", name: "Economics 12th", href: "assets/syllabus/Economics_JCERT_SYLLABUS_CLASS_12.pdf" },
    { class: "12", name: "English 12th", href: "assets/syllabus/JAC_12th_English_Syllabus.pdf" },
    { class: "12", name: "Hindi 12th", href: "assets/syllabus/JAC_12th_Hindi_Elective_Syllabus.pdf" },
    { class: "12", name: "History 12th", href: "assets/syllabus/JAC_12th_HISTORY_Syllabus.pdf" },
    { class: "12", name: "Pol. Science 12th", href: "assets/syllabus/JAC_12th_POLTICAL_SCIENCE_Syllabus.pdf" },
    // { class: "12", name: "Computer Science", href: "assets/dummy.pdf" },
  ];

const R = 8; // one radius to rule them all 😄
  return (
    <Container maxWidth="lg" sx={{ mb: 4 }}>
 {/* const R = 24; // one radius to rule them all 😄 */}

<Box
  sx={{
    p: { xs: 2, sm: 2.5 },
    borderRadius: R,
    position: "relative",
    overflow: "hidden",

    backgroundImage: `linear-gradient(135deg, ${alpha(red[600], 0.10)} 0%, ${alpha(
      ORANGE_ACCENT, 0.10
    )} 100%)`,
    boxShadow: "0 10px 30px rgba(0,0,0,.10)",

    // keep border same radius
    border: `1px solid ${alpha(red[600], 0.16)}`,

    "&:before": {
      content: '""',
      position: "absolute",
      inset: 0,
      backgroundImage:
        "radial-gradient(rgba(255,255,255,.16) 1px, transparent 1.5px)",
      backgroundSize: "14px 14px",
      pointerEvents: "none",
    },

    // ✅ ring matches EXACT radius
    "&:after": {
      content: '""',
      position: "absolute",
      inset: 0,
      borderRadius: R,          // ✅ same as container
      padding: "1.25px",
      background: `linear-gradient(135deg, ${alpha(red[600], 0.65)}, ${alpha(
        ORANGE_ACCENT,
        0.8
      )})`,
      WebkitMask:
        "linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0)",
      WebkitMaskComposite: "xor",
      maskComposite: "exclude",
      pointerEvents: "none",
    },
  }}
>

    {/* subtle corner glow accents */}
    <Box
      sx={{
        pointerEvents: "none",
        position: "absolute",
        inset: 0,
        background:
          `radial-gradient(400px 220px at 0% 0%, ${alpha("#fff", .20)} 0%, transparent 60%),
           radial-gradient(420px 260px at 100% 100%, ${alpha("#fff", .12)} 0%, transparent 65%)`,
      }}
    />

    {/* Header row */}
    <Box sx={{
      mb: 1.5,
      display: "flex",
      alignItems: { xs: "flex-start", sm: "center" },
      justifyContent: "space-between",
      gap: 1.5,
      flexWrap: "wrap"
    }}>
      <Box>
        <Box
          sx={{
            display: "inline-block",
            px: 1,
            py: 0.5,
            borderRadius: 1,
            bgcolor: alpha(ORANGE_ACCENT, 0.18),
            color: orange[800] || "#ef6c00",
            fontWeight: 900,
            fontSize: { xs: 11.5, sm: 12.5 },
            letterSpacing: 0.2,
          }}
        >
          AISECT Inter College Course Syllabus
        </Box>
        <Typography
          sx={{
            mt: 1,
            fontWeight: 900,
            fontSize: { xs: 20, sm: 22 },
            lineHeight: 1.25,
            background: `linear-gradient(90deg, ${red[700]} 0%, ${ORANGE_ACCENT} 100%)`,
            WebkitBackgroundClip: "text",
            backgroundClip: "text",
            color: "transparent",
          }}
        >
          Download Syllabus
        </Typography>
      </Box>

      {/* Show all CTA */}
      <Button
        component={Link}
        to="/syllabus"
        size="small"
        endIcon={<ChevronRightRoundedIcon />}
        sx={{
          alignSelf: { xs: "flex-end", sm: "center" },
          borderRadius: 2,
          px: 1.25,
          py: 0.5,
          fontWeight: 800,
          textTransform: "none",
          color: red[700],
          bgcolor: alpha("#fff", 0.6),
          border: `1px solid ${alpha(red[600], 0.3)}`,
          backdropFilter: "saturate(140%) blur(4px)",
          transition: "all .2s ease",
          "&:hover": { bgcolor: alpha("#fff", 0.8), borderColor: red[600] },
        }}
      >
        Show all
      </Button>
    </Box>

    <Divider sx={{ mb: 1.5, borderColor: alpha("#000", 0.12) }} />

    {/* Tile grid */}
    <Grid container spacing={1.25}>
      {subjects.map(({ name, href }) => (
        <Grid key={name} item xs={12} sm={6} md={4} lg={3}>
          <Button
            component="a"
            href={href}
            target="_blank"
            rel="noreferrer"
            variant="outlined"
            size="small"
            aria-label={`Download ${name} syllabus (PDF)`}
            sx={{
              width: "100%",
              justifyContent: "space-between",
              textTransform: "none",
              fontSize: { xs: 12.5, sm: 13 },
              py: 1,
              px: 1.25,
              borderRadius: 2,
              minHeight: 44,
              gap: 1,

              // glass tile
              bgcolor: alpha("#fff", 0.65),
              backdropFilter: "saturate(140%) blur(6px)",
              borderColor: alpha("#000", 0.15),
              boxShadow: `0 1px 0 ${alpha("#fff", .9)} inset, 0 6px 18px ${alpha("#000", .06)}`,

              // inner hairline ring
              "&:after": {
                content: '""',
                position: "absolute",
                inset: 0,
                borderRadius: 10,
                border: `1px solid ${alpha("#000", 0.06)}`,
                pointerEvents: "none",
              },

              transition: "transform .18s ease, box-shadow .18s ease, border-color .18s ease, background-color .18s ease",
              "@media (hover: hover) and (pointer: fine)": {
                "&:hover": {
                  transform: "translateY(-2px)",
                  backgroundColor: alpha("#fff", 0.8),
                  borderColor: alpha(red[600], 0.35),
                  boxShadow: `0 1px 0 ${alpha("#fff", .9)} inset, 0 10px 22px ${alpha("#000", .10)}`,
                },
              },

              "& .MuiButton-startIcon": { m: 0, mr: 0.75 },
              "& .MuiButton-endIcon": { m: 0, ml: 0.75, opacity: 0.75 },
            }}
            startIcon={
              <Box
                sx={{
                  width: 24,
                  height: 24,
                  display: "grid",
                  placeItems: "center",
                  borderRadius: "50%",
                  bgcolor: alpha(red[600], 0.12),
                  color: red[700],
                  border: `1px solid ${alpha(red[600], 0.35)}`,
                  boxShadow: `0 2px 6px ${alpha(red[900], 0.15)}`,
                  ".MuiButton-root:hover &": {
                    bgcolor: alpha(red[600], 0.18),
                    borderColor: red[500],
                  },
                }}
              >
                <PictureAsPdfRoundedIcon sx={{ fontSize: 16 }} />
              </Box>
            }
            endIcon={<OpenInNewRoundedIcon sx={{ fontSize: 18 }} />}
          >
            <Box
              sx={{
                display: "-webkit-box",
                WebkitLineClamp: 1,
                WebkitBoxOrient: "vertical",
                overflow: "hidden",
                textOverflow: "ellipsis",
                color: "text.primary",
                fontWeight: 800,
                letterSpacing: 0.2,
              }}
              title={name}
            >
              {name}
            </Box>
          </Button>
        </Grid>
      ))}
    </Grid>

    {/* footer hint + optional "Show all" link */}
    <Box sx={{
      mt: 1.5,
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      flexWrap: "wrap",
      gap: 1
    }}>
      <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
        Tip: Tap a subject to open the latest syllabus in a new tab.
      </Typography>
      <Button
        component={Link}
        to="/syllabus"
        size="small"
        endIcon={<ChevronRightRoundedIcon />}
        sx={{
          textTransform: "none",
          fontWeight: 800,
          px: 1,
          py: 0.25,
          color: red[700],
          borderRadius: 2,
          "&:hover": { backgroundColor: alpha(red[600], 0.08) },
        }}
      >
        Show all syllabus
      </Button>
    </Box>
  </Box>
</Container>

  );
}
